/* eslint-disable no-empty */
import React, { useEffect, useRef } from 'react';
import snakeCase from 'lodash.snakecase';
import { Helmet } from 'react-helmet';
import camelCase from 'lodash.camelcase';
import lowerCase from 'lodash.lowercase';
import queryString from 'query-string';
import  semver  from 'semver';
import { browserName } from 'react-device-detect';
import {
  getHours, getDay, getMonth, getYear, getDate, differenceInHours
} from 'date-fns';
import { matchPath } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { purchaseDetailsTypes, appThemes, topupFlows } from './const';

export const isNotificationSupported = () => (
  typeof window !== 'undefined'
  && 'Notification' in window
  && 'serviceWorker' in navigator
);

export const hideBodyScroll = () => {
  const invisibleScrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty(
    '--invisible-scrollbar-width',
    `${ invisibleScrollbarWidth }px`
  );

  // Save current scroll position
  const { scrollY } = window;
  document.body.style.setProperty('position', 'fixed');
  document.body.style.setProperty('top', `-${ scrollY }px`);
  document.body.style.setProperty('width', '100%');
  document.body.style.setProperty('overflow', 'hidden');
  document.body.style.setProperty('-webkit-overflow-scrolling', 'touch');

  // Store scroll position for restoration
  document.body.setAttribute('data-scroll-y', scrollY);
};

export const unlockBodyScroll = () => {
  // Restore scroll position
  const scrollY = document.body.getAttribute('data-scroll-y');
  document.body.style.setProperty('position', '');
  document.body.style.setProperty('top', '');
  document.body.style.setProperty('width', '');
  document.body.style.setProperty('overflow', 'unset');
  document.documentElement.style.setProperty('--invisible-scrollbar-width', '0px');

  if (scrollY) {
    window.scrollTo(0, parseInt(scrollY, 10));
    document.body.removeAttribute('data-scroll-y');
  }
};

export const paramOrNul = (key, value) => (value || value === undefined || value === 0 ? { [key]: value } : null);

export const mobileClickSource = (queryString.parse(window.location.search) || {}).purchase_screen || (queryString.parse(window.location.search) || {}).click_source;

export const clickSourceOrMobileClickSource = (clickSource) => mobileClickSource || clickSource;

export const getStartChatClickSource = (location) => {
  const startChatClickSource = location?.state && location?.state?.startChatClickSource ? location?.state?.startChatClickSource : 'direct';
  return startChatClickSource;
};

export const isMobile = () => parseInt(getComputedStyle(document.documentElement).getPropertyValue('--window-width'), 10) <= window.shared.phoneOnlyUpSize;

const clientPlatforms = {
  pgapp: 'pgapp',
  poapp: 'poapp',
  kasamba: 'kasamba',
  psapp: 'psapp'
};

const fromMobileAppHandler = () => {
  const search = (queryString.parse(window.location.search) || {});
  if (search.pg_client === clientPlatforms.pgapp) return true;
  if (Object.keys(clientPlatforms).map(k => clientPlatforms[k]).includes(search.client_platform)) return true;
  return false;
};

export const fromMobileApp = fromMobileAppHandler();

export const isOldMobileApp = (queryString.parse(window.location.search) || {}).pg_client === 'pgapp';

export const getClientPlatform = () => {
  const search = (queryString.parse(window.location.search) || {});
  // posible value pgapp, poapp, kasamba, psapp
  if (search.pg_client || search.client_platform) return 'customer app';
  return 'customer web';
};

export const getClientPlatformForAPI = () => {
  const platform = getClientPlatform();
  return platform === 'customer web' ? 'Web' : 'app';
};

export const browserContext = { browser_context: browserName };

export const isWebView = () => {
  if (typeof window === 'undefined') { return false; }

  const { navigator } = window;

  const { standalone } = navigator;
  const userAgent = navigator.userAgent.toLowerCase();
  const safari = /safari/.test(userAgent);
  const ios = /iphone|ipod|ipad|macintosh/.test(userAgent);
  const iosIpadWebView = ios && !safari;

  return ios ? ((!standalone && !safari) || iosIpadWebView) : userAgent.includes('wv');
};

export const isIOS = () => {
  if (typeof window === 'undefined') { return false; }
  const { navigator } = window;
  const userAgent = navigator.userAgent.toLowerCase();
  const ios = /iphone|ipod|ipad|macintosh/.test(userAgent);
  return ios;
};

export const isSafari = () => {
  if (typeof window === 'undefined') { return false; }
  const { navigator } = window;
  const userAgent = navigator.userAgent.toLowerCase();
  const safari = /safari/.test(userAgent) && !/chrome|crios|android|fxios|edg/i.test(userAgent);
  return safari;
};

export const isPGW = () => window.location.host?.includes('purplegarden');

export const isPOW = () => window.location.host?.includes('purpleocean');

export const isKA = () => process.env.APP_CONTEXTS === 'ka';

export const isPS = () => process.env.APP_CONTEXTS === 'ps';

export const isPG = () => process.env.APP_CONTEXTS.includes('pg');

export const getProjectPrefix = () => {
  let prefix = 'pg';
  if (isKA()) {
    prefix = 'ka';
  } else if (isPS()) {
    prefix = 'ps';
  } else if (isPOW()) {
    prefix = 'po';
  } else {
    prefix = 'pg';
  }
  return prefix;
};

export const getAppName = () => {
  if (isPOW()) return 'Purple Ocean';
  if (isKA()) return 'Kasamba';
  if (isPS()) return 'Psiquicos';
  return 'Purple Garden';
};

export const appContext = {
  po: 'po',
  pg: 'pg',
  ka: 'ka',
  ps: 'ps'
};

export const getIcon = ({
  iconName, requireContext, forAppContext = false, appTheme
}) => {
  let name = iconName;
  let appCode;
  if (forAppContext) {
    if (isPGW()) {
      appCode = appContext.pg;
      name = `${ appCode }_${ name }`;
    } else if (isKA()) {
      appCode = appContext.ka;
      name = `${ appCode }_${ name }`;
    } else {
      appCode = appContext.po;
      name = `${ appCode }_${ name }`;
    }
  }
  const images = requireContext.keys().map(requireContext);
  let img = images.find(item => item.includes(name));
  if (appTheme && Object.keys(appThemes).includes(appTheme)) {
    const nameWithTheme = `${ name }_${ appTheme }`;
    const imgWithTheme = images.find(item => item.includes(nameWithTheme));
    if (imgWithTheme) img = imgWithTheme;
  }
  if (!img) {
    const unknowImg = images.find(item => item.includes('unknow')); // Need for unknown credit card
    if (unknowImg) return unknowImg;
    if (forAppContext && appCode) {
      const nameWithoutAppContext = name.replace(`${ appCode }_`, '');
      const imgWithoutAppContext = images.find(item => item.includes(`${ nameWithoutAppContext }`));
      return imgWithoutAppContext;
    }
  }
  return img;
};

export const compareObjects = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2);

function UsePreviousValue({ value }) {
  const ref = useRef();
  useEffect(() => { ref.current = value; });
  return ref.current;
}

export default UsePreviousValue;

const ignoreConvertKeys = ['analytic_events', 'manual_analytic_events', 'analytics', 'skip_event_properties'];

const convertCase = (oldObject, converterFunction) => {
  let newObject;

  if (!oldObject || typeof oldObject !== 'object' || !Object.keys(oldObject).length) return oldObject;

  if (Array.isArray(oldObject)) {
    newObject = oldObject.map(element => convertCase(element, converterFunction));
  } else {
    newObject = {};
    Object.keys(oldObject).forEach(oldKey => {
      const newKey = converterFunction(oldKey);
      if (ignoreConvertKeys.includes(oldKey)) {
        newObject[newKey] = oldObject[oldKey]; // preserve original values
        return;
      }
      newObject[newKey] = convertCase(oldObject[oldKey], converterFunction);
    });
  }

  return newObject;
};

const mergeUiSettingsIfNeed = (obj) => { // Temporary fix    merge ui_settings and uiSettings if both exist in the object
  if (!obj || typeof obj !== 'object' || !Object.keys(obj).length) return obj;
  const updatedObj = obj;
  if (updatedObj.client_settings) {
    if (updatedObj.client_settings.ui_settings && updatedObj.client_settings.uiSettings) {
      updatedObj.client_settings.uiSettings = { ...updatedObj.client_settings.uiSettings, ...updatedObj.client_settings.ui_settings };
    }
    return updatedObj;
  }

  if (updatedObj.ui_settings && updatedObj.uiSettings) {
    updatedObj.uiSettings = { ...updatedObj.uiSettings, ...updatedObj.ui_settings };
  }
  return updatedObj;
};

export const toCamelCase = (obj) => convertCase(mergeUiSettingsIfNeed(obj), camelCase);
export const toSnakeCase = (obj) => convertCase(mergeUiSettingsIfNeed(obj), snakeCase);
export const toLowerCaseSpaced = (obj) => convertCase(mergeUiSettingsIfNeed(obj), lowerCase);

export const convertStringToSnakeCase = (str) => {
  str = str[0].toLowerCase() + str.slice(1, str.length).replace(/[A-Z]/g, letter => `_${ letter.toLowerCase() }`);
  str  = str.replaceAll(' _', '_');

  return str.replaceAll(' ', '_').replace(/(^_*|_*$)/g, '');
};

export const convertStringToCamelCase = (str) => {
  const arr = str.match(/[a-z]+|\d+/gi);
  return arr.map((m, i) => {
    let low = m.toLowerCase();
    if (i !== 0) {
      low = low.split('').map((s, k) => (k === 0 ? s.toUpperCase() : s)).join``;
    }
    return low;
  }).join``;
};

/**
 * Appends `af_channel` (and an optional `campaign`) to an AppsFlyer OneLink base
 * from the dynamic config (`url`, `appStoreUrl`, `playStoreUrl`). The bases already
 * carry the attribution params Rails resolves per visit (`pid`, `c`, `deep_link_value`),
 * so params are appended rather than replaced. Returns `null` when the server didn't
 * ship a base URL, so the link is simply omitted.
 *
 * @param {Object} [options]
 * @param {string} [options.afChanel] AppsFlyer channel identifying the surface that linked out.
 * @param {string} [options.url] OneLink base from the dynamic config.
 * @param {string} [options.campaign] AppsFlyer campaign, when a surface needs its own attribution.
 * @returns {string|null}
 */
export const downloadAppLink = ({ afChanel, url, campaign } = {}) => {
  if (!url) return null;
  const parsedURL = url.replace(/&amp;/gi, '&');
  const additionalParams = queryString.stringify({ af_channel: afChanel, campaign }, { skipNull: true });
  if (!additionalParams) return parsedURL;
  // The base may arrive without a query string, so pick the separator rather than always `&`.
  return `${ parsedURL }${ parsedURL.includes('?') ? '&' : '?' }${ additionalParams }`;
};

export const emailIsValid = (email) => {
  const re = /^[A-Z0-9a-z._%+-]+@([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}$/;
  return re.test(String(email.trim()).toLowerCase());
};

export const nicknameIsValid = (nickname) => {
  const re = /^[a-zA-Z0-9]{2,20}$/;
  return re.test(String(nickname.trim()).toLowerCase());
};

export const paymentKindToAnalyticsName = (kind) => {
  const kindList = {
    cc: 'credit card',
    pp: 'paypal',
    iap: 'IAP',
    ap: 'apple pay',
    none: 'none',
    am: 'apple merchant token',
    gp: 'google pay'
  };
  return kindList[kind];
};

export const noPaymentMethodsEventData = (options) => {
  if (!options) return ({ 'available methods': undefined });
  const hasNoPaymentMethodsSet = options.find((o) => o.adding);
  if (hasNoPaymentMethodsSet) {
    const availableMethods = [];
    options.forEach((o) => {
      if (o.adding) availableMethods.push(paymentKindToAnalyticsName(o.kind));
    });
    return ({ 'available methods': availableMethods.join(' + ') });
  }
  return ({ 'available methods': undefined });
};

export const currentPaymentMethodData = () => {
  const { getState } = window.store;
  const { paymentSources: { current } } = getState();
  if (current) {
    const { kind, id, gatewayName } = current;
    const previousPaymentProps = {
      'prev payment method': paymentKindToAnalyticsName(kind),
      'prev payment id' : id,
      'prev payment gateway': gatewayName
    };
    return previousPaymentProps;
  }
  return null;
};

export const getPurchaseScreenForPaymentSourcesEvent = (clickSource) => {
  let purchaseScreen = clickSourceOrMobileClickSource(clickSource);
  if (window.location.pathname.includes('/payment_sources')) purchaseScreen = 'payment methods';
  return purchaseScreen;
};

export const tryParseJSONObject = (jsonString) => {
  try {
    const o = JSON.parse(jsonString);
    if (o && typeof o === 'object') return o;
  } catch { }
  return false;
};

export const capitalizeFirstChar = (str) => {
  if (!str) return null;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatCardName = (str) => {
  if (!str) return null;
  const splitedString =  str.split('_');
  let cardName = '';
  splitedString.map((item) => {
    let s = item;
    if (s === 'mastercard') {
      s = s.slice(0, s.indexOf('card')) + capitalizeFirstChar(s.slice(s.indexOf('card')));
    }
    cardName += ` ${ capitalizeFirstChar(s) }`;
    return null;
  });
  return cardName.trim();
};

const purchaseTypes = {
  side_menu: purchaseDetailsTypes.SIDE_MENU,
  live_chat: purchaseDetailsTypes.CHAT,
  voice_call: purchaseDetailsTypes.VOICE_CHAT,
  video_call: purchaseDetailsTypes.VIDEO_CHAT,
  matchup_promo: purchaseDetailsTypes.AFFILIATE_PROMO_POPUP,
  holistic_service: purchaseDetailsTypes.HOLISTIC_SERVICE
};

export const getPurchaseType = (purchaseType) => {
  if (purchaseType) return purchaseTypes[purchaseType];
  return purchaseDetailsTypes.SIDE_MENU;
};

export const getPrice = (price) => parseFloat(price || 15);
export const getBonus = (bonus) => parseFloat(bonus || 0);
export const getDuration = (duration) => parseFloat(duration);
export const getAdvisorId = (advisorId) => parseFloat(advisorId);
export const getClickSource = (clickSource) => (clickSource || '').split('_').join(' ');
export const getIsPayg = (payg) => payg && payg.toLowerCase() === 'true';

export const hideEmailAdress = (email) => {
  if (!emailIsValid(email)) return email;
  const emailSplit = email.split('@');
  const emailFirstPart = emailSplit[0];
  const firstNCharts = emailFirstPart.slice(0, 3);
  const lastChar = emailFirstPart.length >= 4 ? emailFirstPart.slice(-1) : '';
  const hidedEmail = `${ firstNCharts }****${ lastChar }@${ emailSplit[1] }`;
  return hidedEmail;
};

export const getMinPrice = () => {
  const userReducer = window.store.getState().user;
  return (userReducer.user?.minCreditRequestedCents || 1000) / 100;
};

export const getCurrency = () => {
  const userReducer = window.store.getState().user;
  return userReducer.user?.currency;
};

export const calculateDiffHandler = ({ purchaseType, price, clientAvailableCredit }) => {
  if (purchaseType === purchaseDetailsTypes.SIDE_MENU
      || purchaseType === purchaseDetailsTypes.AFFILIATE_PROMO_POPUP) {
    return price;
  }
  return price - parseFloat(clientAvailableCredit);
};

export const calculateRequiredFunds = ({ diffPrice, purchaseType, topupFlow }) => {
  const minPrice = getMinPrice();
  if ([purchaseDetailsTypes.AFFILIATE_PROMO_POPUP, purchaseDetailsTypes.ADVISOR_BONUS].includes(purchaseType) || topupFlow === topupFlows.quick) return diffPrice;
  if (diffPrice < minPrice) return minPrice;
  return diffPrice;
};

export const getData = ({ date, type }) => {
  const getDataTypes = {
    date: getDate,
    hours: getHours,
    day: (d) => {
      const day = getDay(d);
      return day === 0 ? 7 : day;
    },
    month: getMonth,
    year: getYear
  };
  const itemCount = type === 'month' ? getDataTypes[type](date) + 1 : getDataTypes[type](date);
  return itemCount;
};

export const adjustTimezone = (date) => {
  if (!date) return null;
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
};

const ensureDate = (date) => {
  if (!date) return null;
  if (date instanceof Date) return date;
  return adjustTimezone(new Date(date));
};

export const calculateDifference = ({ date1, date2, type }) => {
  const calculateDifferenceTypes = {
    days: (d1, d2) => Math.floor(Math.abs(differenceInHours(d1, d2)) / 24),
    years: (d1, d2) => {
      let yearsDifference = d1.getFullYear() - d2.getFullYear();

      if (d1.getMonth() < d2.getMonth()
          || (d1.getMonth() === d2.getMonth() && d1.getDate() < d2.getDate())) {
        yearsDifference--;
      }

      return Math.abs(yearsDifference);
    }
  };
  const date1Obj = ensureDate(date1);
  const date2Obj = ensureDate(date2);
  if (!date1Obj || !date2Obj) return null;
  const result = calculateDifferenceTypes[type](date1Obj, date2Obj);
  return result;
};

const isUserDebtCredit = (credit) => {
  const userBalance = window.store.getState()?.user?.user?.clientAvailableCredit;
  return userBalance < 0 && Math.abs(userBalance) === Math.abs(credit);
};

export const getAddCreditUrl = ({
  credit, purchaseType, clickSource, topupFlow, advisorId
}) => {
  if (!window.config.addCreditPath) return '';
  const clickSourceParam = clickSource ? { click_source: clickSource } : {};
  const queryParams = {
    with_payment_sources: true,
    platform: getClientPlatformForAPI(),
    intended_advisor_id: advisorId,
    purchase_type: topupFlow === topupFlows.quick ? 'quick_top_up' : purchaseType?.toLowerCase(),
    ...clickSourceParam
  };
  // if (purchaseType === purchaseDetailsTypes.AFFILIATE_PROMO_POPUP || purchaseType === 'matchup_promo') {
  //   // queryParams = { ...queryParams, is_affiliate_promo_purchase: true };
  //   queryParams = { ...queryParams, purchase_type: purchaseType.toLowerCase() };
  // }

  // // MAYBE NEED
  // if (purchaseType === purchaseDetailsTypes.ADVISOR_BONUS || purchaseType === 'advisor_bonus') {
  //   // queryParams = { ...queryParams, is_dvisor_tips_purchase: true };
  //   queryParams = { ...queryParams, is_affiliate_promo_purchase: true };
  // }

  const {
    context, bonus, price
  } = queryString.parse(window.location.search);

  let url = window.config.addCreditPath.replace('{credit}', credit);
  if (context === 'credit_screen' &&  !isUserDebtCredit(parseFloat(bonus) + parseFloat(price))) {
    const amount = Math.ceil(parseFloat(bonus) + parseFloat(price));
    url = `/my/app_credits/${ amount }`;
  }
  return `${ url }?${ queryString.stringify(queryParams) }`;
};

export const asyncLoadScript = (scriptURL, existingVariable, inregrity) => new Promise((resolve, reject) => {
  if (existingVariable) {
    resolve();
    return;
  }

  const script = document.createElement('script');
  script.src = scriptURL;
  script.async = true;
  if (inregrity) {
    script.integrity = inregrity;
    script.crossOrigin = 'anonymous';
  }
  script.onload = () => resolve();
  script.onerror = (error) => reject(error);
  document.body.appendChild(script);
});

export const withCaptcha = (action, callback) => {
  asyncLoadScript(`https://www.google.com/recaptcha/enterprise.js?render=${ window.config.recaptchaKey }`, window.grecaptcha).then(() => {
    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute(window.config.recaptchaKey, { action })
        .then(token => callback(token));
    });
  });
};

const ckoGetDeviceSessionIdApi = ({ publicKey, riskJsUrl }) => new Promise((resolve, reject) => {
  asyncLoadScript(riskJsUrl, window.Risk).then(() => {
    const risk = window.Risk.init(publicKey);
    risk.publishRiskData()
      .then((deviceSessionId) => resolve(deviceSessionId))
      .catch(error => reject(error));
  }).catch(error => reject(error));
});

const ckoGetDeviceSessionIdApi20 = ({ publicKey, riskJsUrl, jsIntegrity }) => new Promise((resolve, reject) => {
  asyncLoadScript(riskJsUrl, window.Risk, jsIntegrity).then(() => {
    window.Risk.create(publicKey).then(risk => {
      risk.publishRiskData()
        .then((deviceSessionId) => resolve(deviceSessionId))
        .catch(error => reject(error));
    }).catch(error => reject(error));
  }).catch(error => reject(error));
});

export const withCkoGetDeviceSessionIdApi = ({ callback, params }) => {
  const { paymentSources } = window.store.getState();
  if (!paymentSources) return callback(params);
  const currentPaymentSource = paymentSources.current;
  if (!currentPaymentSource?.riskModelConfig) return callback(params);
  if (currentPaymentSource.riskModel === 'riskjs') {
    const { publicKey, jsSrc } = currentPaymentSource.riskModelConfig;
    if (!publicKey) {
      return callback(params);
    }
    return ckoGetDeviceSessionIdApi({ publicKey, riskJsUrl: jsSrc })
      .then((deviceSessionId) => callback({ ...params, deviceSessionId }))
      .catch(() => {
        const error = { error: 'ckoGetDeviceSessionIdApi error' };
        return Promise.reject(error);
      });
  } if (currentPaymentSource.riskModel === 'riskjs20') {
    const { publicKey, jsSrc, jsIntegrity } = currentPaymentSource.riskModelConfig;
    if (!publicKey) {
      return callback(params);
    }
    return ckoGetDeviceSessionIdApi20({ publicKey, riskJsUrl: jsSrc, jsIntegrity })
      .then((deviceSessionId) => callback({ ...params, deviceSessionId }))
      .catch(() => {
        const error = { error: 'ckoGetDeviceSessionIdApi error' };
        return Promise.reject(error);
      });
  }
  return callback(params);
};

export const getAppTheme = () => toCamelCase(queryString.parse(window.location.search)).theme;

export const getTextColorForTheme = () => {
  const theme = getAppTheme();
  if (theme === appThemes.dark) return '#EEEEEE';
  return '#121212';
};

const match = ({ pathname, path }) => matchPath({ path: `${ pathname }`, caseSensitive: true, end: true }, `${ path }`);

export const matchPaths = ({ pathname, path }) => {
  let m;
  if (Array.isArray(pathname)) {
    pathname.find((p) => {
      m = match({ pathname: p, path });
      return m;
    });
  } else {
    m = match({ pathname, path });
  }
  return m;
};

export const isPaygAndNotEligibleToPayAsYouGo = ({ isPayg, eligibleToPayAsYouGo }) => isPayg && eligibleToPayAsYouGo !== undefined && !eligibleToPayAsYouGo;

export const removeEmptyValueInObject = (object) => {
  let clearedObject = {};
  Object.keys(object).forEach((key) => {
    if (object[key] !== null && object[key] !== undefined) {
      clearedObject = { ...clearedObject, [key]: object[key] };
    }
  });
  return clearedObject;
};

export const isVersionHigher = (version) => {
  const search = (queryString.parse(window.location.search) || {});
  const mobileVersion = search?.app_version;
  if (!mobileVersion) return false;

  return semver.gte(mobileVersion, version);
};

export const updatedPurchaseURL = ({ purchaseURL, extraParams }) => {
  if (extraParams) {
    const purchaseURLSearch = purchaseURL.slice(purchaseURL.indexOf('?'));
    const purchaseURLPathName = purchaseURL.slice(0, purchaseURL.indexOf('?'));
    const parsedPurchaseURLSearch = queryString.parse(purchaseURLSearch);
    const parsedExtraParams = queryString.parse(extraParams);
    const updatedUrlSearch = queryString.stringify({
      ...parsedPurchaseURLSearch, ...parsedExtraParams
    });
    const updatedUrl = `${ purchaseURLPathName }?${ updatedUrlSearch }`;
    return updatedUrl;
  }
  return purchaseURL;
};

export const saveDataToStorage = (key, data) => {
  if (!window.localStorage) return;
  try {
    localStorage.setItem(key, data);
  } catch (e) {
    if (e.code === DOMException.QUOTA_EXCEEDED_ERR) {
      localStorage.removeItem('logs_batch');
    }
  }
};

export const getDataFromStorage = (key) => {
  if (!window.localStorage) return null;
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const removeDataFromStorage = (key) => {
  if (!window.localStorage) return;
  try {
    localStorage.removeItem(key);
  } catch {
  }
};

export const getActiveOffer = () => {
  const offers = window.currentUserId ? window.store?.getState()?.user?.user?.bonusInfos : window.bonusInfos ?? null;
  if (offers?.length) return offers[0];
  return null;
};

export const formatCurrency = (price) => {
  const formater = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    trailingZeroDisplay: 'stripIfInteger'
  });
  return formater.format(price);
};

export const addMetaRobotsNoIndex = () => (
  <Helmet>
    <meta name="robots" content="noindex" />
  </Helmet>
);

export const noInternetConnectionError = 'No internet connection';

export const getErrorMessage = async (error) => {
  try {
    const data = await (typeof error?.json === 'function' ? error.json() : null);
    if (typeof data === 'string') return data;
    if (data?.error) return data.error;
    if (data?.message) return data.message;
    if (Array.isArray(data?.errors)) return data.errors.join(', ');
    if (error?.message) {
      if (
        error?.message === 'Failed to fetch'
        || error?.message === 'Load failed'
        || error?.message?.includes('offline')
        || error?.message?.includes('NetworkError')
        || error?.message?.includes('FetchEvent.respondWith received an error')
      ) {
        return noInternetConnectionError;
      }
      return error.message;
    }
    return 'Unknown error';
  } catch {
    if (error?.status && error?.statusText) return `${ error?.status } ${ error?.statusText }`;
    return error?.message || 'Unknown error';
  }
};

export const createTemplateWithData = (templateName, data) => {
  const templateEl = document.createElement('div');
  templateEl.style.display = 'none';
  templateEl.id = templateName;
  templateEl.innerText = JSON.stringify(data);
  const container = document.getElementById('app-root');
  container.appendChild(templateEl);
};

const levenshteinDistance = (a, b) => {
  if (a.length === 0) return b.length;
  if (b.length === 0) return a.length;

  const matrix = [];

  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }
  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }

  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b[i - 1] === a[j - 1]) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1, // substitution
          matrix[i][j - 1] + 1,     // insertion
          matrix[i - 1][j] + 1      // deletion
        );
      }
    }
  }

  return matrix[b.length][a.length];
};

export const fuzzyMatch = (query, nickname) => {
  if (!query || !nickname) return null;

  const queryLower = query.toLowerCase();
  const nicknameLower = nickname.toLowerCase();
  const queryLen = queryLower.length;
  const nicknameLen = nicknameLower.length;

  // Try substring windows of different sizes to account for insertions/deletions
  // Window sizes: queryLen - 1, queryLen, queryLen + 1
  const windowSizes = [queryLen, queryLen - 1, queryLen + 1].filter(size => size > 0);

  // Generate all valid (start, windowSize) combinations
  const startPositions = Array.from({ length: nicknameLen }, (_, i) => i);
  const combinations = startPositions.flatMap(start => windowSizes
    .filter(windowSize => start + windowSize <= nicknameLen)
    .map(windowSize => ({ start, windowSize })));

  // Find all matches with distance <= 1
  const matches = combinations
    .map(({ start, windowSize }) => {
      const substring = nicknameLower.substring(start, start + windowSize);
      const distance = levenshteinDistance(queryLower, substring);
      return distance <= 1 ? { start, end: start + windowSize, distance } : null;
    })
    .filter(m => m !== null);

  if (matches.length === 0) return null;

  // Sort by distance first (exact matches first), then by start position
  matches.sort((a, b) => {
    if (a.distance !== b.distance) return a.distance - b.distance;
    return a.start - b.start;
  });

  const bestMatch = matches[0];
  const positions = Array.from(
    { length: bestMatch.end - bestMatch.start },
    (_, i) => bestMatch.start + i
  );

  return { positions, distance: bestMatch.distance };
};

export const highlightMatch = (nickname, query) => {
  if (!query || !nickname) return nickname;

  const theMatch = fuzzyMatch(query, nickname);
  if (!theMatch || !theMatch.positions || theMatch.positions.length === 0) {
    return nickname;
  }

  // Since positions are now consecutive, highlight the entire range
  const start = theMatch.positions[0];
  const end = theMatch.positions[theMatch.positions.length - 1] + 1;

  const parts = [];

  if (start > 0) {
    parts.push(nickname.substring(0, start));
  }

  parts.push(<strong key={ start }>{ nickname.substring(start, end) }</strong>);

  if (end < nickname.length) {
    parts.push(nickname.substring(end));
  }

  return parts;
};

export const getReferrerUrl = () => {
  const cookies = new Cookies();
  const lastReferral = cookies.get('last_referral');

  let currentReferralDomain;
  try {
    const url = new URL(document.referrer);
    currentReferralDomain = url.origin;
  } catch {
    currentReferralDomain = null;
  }

  if (currentReferralDomain === window.location.origin) {
    return lastReferral;
  }

  return document.referrer;
};
